import React from 'react';
import { CheckCircleIcon, XCircleIcon } from 'lucide-react';
export function ForWhoSection() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-215">
      <div className="max-w-4xl mx-auto px-6" data-id="element-216">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-217">
          ¿Para quién es este curso?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-218">
          {/* For You */}
          <div className="bg-green-50 border border-green-200 rounded-2xl p-8" data-id="element-219">
            <div className="flex items-center gap-3 mb-6" data-id="element-220">
              <CheckCircleIcon className="w-8 h-8 text-green-600" data-id="element-221" />
              <h3 className="text-xl font-bold text-gray-900" data-id="element-222">
                Este curso es para ti si:
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-223">
              <li className="flex items-start gap-3 text-gray-700" data-id="element-224">
                <span className="text-green-600 font-bold mt-0.5" data-id="element-225">✓</span>
                Nunca has hecho anuncios en Meta Ads y quieres empezar bien.
              </li>
              <li className="flex items-start gap-3 text-gray-700" data-id="element-226">
                <span className="text-green-600 font-bold mt-0.5" data-id="element-227">✓</span>
                Probaste una vez, te mareaste y lo dejaste.
              </li>
              <li className="flex items-start gap-3 text-gray-700" data-id="element-228">
                <span className="text-green-600 font-bold mt-0.5" data-id="element-229">✓</span>
                Quieres aprender a traer tráfico, leads o mensajes a tu negocio,
                sin depender totalmente de una agencia.
              </li>
              <li className="flex items-start gap-3 text-gray-700" data-id="element-230">
                <span className="text-green-600 font-bold mt-0.5" data-id="element-231">✓</span>
                Eres freelancer/marketer y quieres sumar Meta Ads como habilidad
                básica para ofrecer a clientes.
              </li>
              <li className="flex items-start gap-3 text-gray-700" data-id="element-232">
                <span className="text-green-600 font-bold mt-0.5" data-id="element-233">✓</span>
                Te gusta aprender con ejemplos, viendo cómo se hace en vivo y
                pudiendo preguntar.
              </li>
            </ul>
          </div>

          {/* Not For You */}
          <div className="bg-red-50 border border-red-200 rounded-2xl p-8" data-id="element-234">
            <div className="flex items-center gap-3 mb-6" data-id="element-235">
              <XCircleIcon className="w-8 h-8 text-red-600" data-id="element-236" />
              <h3 className="text-xl font-bold text-gray-900" data-id="element-237">
                No es para ti si:
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-238">
              <li className="flex items-start gap-3 text-gray-700" data-id="element-239">
                <span className="text-red-600 font-bold mt-0.5" data-id="element-240">✗</span>
                Ya gestionas campañas avanzadas, escalas fuerte y buscas
                estrategias muy complejas.
              </li>
              <li className="flex items-start gap-3 text-gray-700" data-id="element-241">
                <span className="text-red-600 font-bold mt-0.5" data-id="element-242">✗</span>
                No estás dispuesto a dedicar al menos unas horas por semana para
                ver las clases y aplicar.
              </li>
              <li className="flex items-start gap-3 text-gray-700" data-id="element-243">
                <span className="text-red-600 font-bold mt-0.5" data-id="element-244">✗</span>
                Buscas un truco mágico para hacerte rico sin aprender nada.
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}